import { useEffect, useState } from 'react';
import API, { API_NEW } from 'src/API';
import useModal from './useModal';
import { ENDPOINTS } from '../Constants/index';
import { AuthInfo } from 'Src/Types/ReDoc/Auth';

const useAuth = () => {
	const { showError, showWaiting, setWaiting } = useModal();
	const [authInfo, setAuthInfo] = useState<AuthInfo>();

	useEffect(() => {
		return updateAuthInfo();
	}, []);

	const updateAuthInfo = () => {
		showWaiting('Проверка авторизации');
		API_NEW.onRequest<AuthInfo>({
			url: window.host + ENDPOINTS.GET_CURRENT_USER_INFO,
		})
			.then((res) => {
				if (res.hasError || !res.result) {
					showError(res.errorMessage, 'Ошибка', res.traceparent);
					return;
				}
				setAuthInfo(res.result);
			})
			.finally(() => {
				return setWaiting(false);
			});
	};

	const logoute = () => {
		// удалеине куки номера окна МФЦ
		API.Cookies.deleteCook('mfcWindowNumber', '/');
		API.Cookies.deleteCook('_justLoggedIn', '/');
		localStorage.removeItem('getOrganizationListcurrentUserOrg');
		localStorage.removeItem('currentGetRegisteredPlugins');
		window.location.replace(
			`${window.host}/WebInterfaceModule/Authentication/Logout?returnUrl=${window.devHost}/new#`,
		);
	};

	return { authInfo, updateAuthInfo, logoute };
};

export default useAuth;
